import { actionCreatorFactory } from 'typescript-fsa';
import { IApiErrorParams } from '@cbridge-packages/api';
import { IResolverMeta } from '@cbridge-utils/redux-observable';
import { IAdjustmentProfileData, IAdjustment, IAdjustmentProfileDataRecord } from './adjustmentProfile.interface';

export namespace AdjustmentProfileAction {
  const actionCreator = actionCreatorFactory('AdjustmentProfile');

  interface IAdjustmentProfileParams extends IAdjustment, Pick<IResolverMeta, 'reject'> {}

  export const create = actionCreator.async<IAdjustmentProfileParams, { adjustmentId: IAdjustment['adjustmentId'] }, void>('CREATE');
  export const update = actionCreator.async<IAdjustmentProfileParams, IAdjustmentProfileDataRecord, void>('UPDATE');
  export const remove = actionCreator.async<
    {
      adjustmentId: IAdjustmentProfileParams['adjustmentId'];
    },
    void,
    void
  >('REMOVE');
  export const loadList = actionCreator.async<void, IAdjustmentProfileData, void>('LOAD');

  export const exportFile = actionCreator.async<void, void, IApiErrorParams>('EXPORT_FILE');

  export const destroy = actionCreator('DESTROY');
}
